export const setCookie = (name, value, exdate) => {
  exdate && (exdate = new Date(exdate).toUTCString())
  const c_value =
    escape(value) +
    (exdate === null || exdate === undefined ? '' : '; expires=' + exdate)
  document.cookie = name + '=' + c_value
}

export default setCookie
